/****************************************************************************************************
 * MS Forms "Form" resource API Client.
 *
 * @author Dimitris Gkoulis <gkould@gmail.com>
 * @createdAt 21 May 2021
 * @lastModifiedAt Saturday 11 December 2021
 ****************************************************************************************************/

import ApiUrlProvider from '../api-url-provider';
import BaseApiClient from '../base-api-client';

const FormsFormBasicApiClient = {
    createForm (data) {
        const url = ApiUrlProvider.kernelVersionedApi('forms');
        return BaseApiClient.post(url, data);
    },
    updateForm (data) {
        const url = ApiUrlProvider.kernelVersionedApi('forms');
        return BaseApiClient.put(url, data);
    },
    getForm (id) {
        const url = ApiUrlProvider.kernelVersionedApi('forms/' + id);
        return BaseApiClient.get(url);
    },
    deleteForm (id) {
        const url = ApiUrlProvider.kernelVersionedApi('forms/' + id);
        return BaseApiClient.delete(url);
    },
    getAllForms (page = 0, size = 10, sortField = 'id', sortDirection = 'desc') {
        const url = ApiUrlProvider.kernelVersionedApi('forms');
        return BaseApiClient.get(url, {
            params: {
                page: page,
                size: size,
                sort: sortField + ',' + sortDirection
            }
        });
    },
    getAllFormsByFormGroupId (formGroupId = null, page = 0, size = 10, sortField = 'id', sortDirection = 'desc') {
        const url = ApiUrlProvider.kernelVersionedApi('forms');
        return BaseApiClient.get(url, {
            params: {
                formGroupId: formGroupId,
                page: page,
                size: size,
                sort: sortField + ',' + sortDirection
            }
        });
    }
};

export default FormsFormBasicApiClient;
